import * as requestFromServer from "./ReplaceEmoneyCrud";
import { ReplaceEmoneySlice, setLoading } from "./ReplaceEmoneySlice";
import { UISlice } from "../UISlice";

const { actions: ReplaceEmoneyActions } = ReplaceEmoneySlice;
const { actions: UIActions } = UISlice;

export const fetchReplaceEmoneyRequests =
  (type, searchTerm = "", page = 1, sortKey, sortDirection) =>
  (dispatch) => {
    dispatch(UIActions.openLoader());
    dispatch(setLoading(true));

    let fetchFunction;
    switch (type) {
      case "pending":
        fetchFunction = requestFromServer.pendingEMoneyRequestsApi;
        break;
      case "accepted":
        fetchFunction = requestFromServer.acceptedEMoneyRequestsApi;
        break;
      case "rejected":
      default:
        fetchFunction = requestFromServer.rejectedEMoneyRequestsApi;
        break;
    }

    return fetchFunction(searchTerm, page, sortKey, sortDirection)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            ReplaceEmoneyActions.setReplaceEmoneyData({
              data: response.data.data,
              paginator: response.data.paginator,
            })
          );
        } else {
          throw new Error("Failed to fetch requests");
        }
      })
      .catch((error) => {
        const errorMessage = Array.isArray(error.response?.data?.message)
          ? error.response.data.message.join(", ") // Join array of messages
          : error.response?.data?.message ||
            error.message ||
            "An error occurred";

        dispatch(ReplaceEmoneyActions.catchError(errorMessage));
      })
      .finally(() => {
        dispatch(setLoading(false));

        dispatch(UIActions.closeLoader());
      });
  };

export const viewReplaceEmoneyDetails = (id) => (dispatch) => {
  dispatch(UIActions.openLoader());

  return requestFromServer
    .viewEMoneyDetailsApi(id)
    .then((response) => {
      if (response.data.status) {
        dispatch(
          ReplaceEmoneyActions.setReplaceEmoneyDetails(response.data.data)
        );
      } else {
        throw new Error("Failed to fetch details");
      }
    })
    .catch((error) => {
      const errorMessage = Array.isArray(error.response?.data?.message)
        ? error.response.data.message.join(", ")
        : error.response?.data?.message || error.message || "An error occurred";

      dispatch(ReplaceEmoneyActions.catchError(errorMessage));
    })
    .finally(() => {
      dispatch(UIActions.closeLoader());
    });
};

export const acceptReplaceEmoneyRequest =
  (id, acceptanceNote, onSuccess) => (dispatch) => {
    dispatch(UIActions.openLoader());

    const data = { acceptance_note: acceptanceNote };

    return requestFromServer
      .acceptEMoneyRequestApi(id, data)
      .then((response) => {
        if (response.status) {
          dispatch(ReplaceEmoneyActions.clearReplaceEmoneyDetails());
          if (onSuccess) onSuccess();
        } else {
          throw new Error("Failed to accept request");
        }
      })
      .catch((error) => {
        const errorMessage = Array.isArray(error.response?.data?.message)
          ? error.response.data.message.join(", ")
          : error.response?.data?.message ||
            error.message ||
            "An error occurred";

        dispatch(ReplaceEmoneyActions.catchError(errorMessage));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
      });
  };

export const rejectReplaceEmoneyRequest =
  (id, rejectionNote, onSuccess) => (dispatch) => {
    dispatch(UIActions.openLoader());

    const data = { rejection_note: rejectionNote };

    return requestFromServer
      .rejectEMoneyRequestApi(id, data)
      .then((response) => {
        if (response.status) {
          dispatch(ReplaceEmoneyActions.clearReplaceEmoneyDetails());
          if (onSuccess) onSuccess();
        } else {
          throw new Error("Failed to reject request");
        }
      })
      .catch((error) => {
        const errorMessage = Array.isArray(error.response?.data?.message)
          ? error.response.data.message.join(", ")
          : error.response?.data?.message ||
            error.message ||
            "An error occurred";

        dispatch(ReplaceEmoneyActions.catchError(errorMessage));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
      });
  };
